var VCA = VCA || {};

VCA.DashboardHeader = (function ($) {
    let ui = {};
    let numOfNotifications = 0;
    let notifsSecondArray = [];

    function cacheUI() {
        ui.$NotificationsList = $('#DashboardNotificationsList');
        ui.$NotificationsCount = $('.header-info__notifications-count');
        ui.$NotificationsCancelBtn = $('.notifications-cancel-btn');
        ui.$NotificationsClearAllBtn = $('#NotificationsClearAllBtn');    
    }

    function bindEvents() {
        $('.header-info__truncated-msg').on('click', showMsgModal);
        $('.header-info__notifications').on('click', showNotificationsModal);
        ui.$NotificationsCancelBtn.on('click', deleteNotification);
        ui.$NotificationsClearAllBtn.on('click', clearAll);
    }

    function showMsgModal() {
        $('#MessageModal').modal('show');
    }

    function showNotificationsModal() {
        $('#NotificationsModal').modal('show');
    }

    function checkCookies() {
        let browserCookies = getCookie('notification');
        let browserCookiesNotifs2 = getCookie('notification2');

        if (browserCookies == null) {
            calcLengthOfNotifications();
            return;
        } else {
            let storedNotifsCookiesValues = browserCookies.split(',');
            let storedNotifsCookies2Values = browserCookiesNotifs2.split(',');

            //loop through each notification item 
            ui.$NotificationsList.find('.db-notification-item').each((idx,notif) => {
                let notifDataAttr = $(notif).data('notificationid');
                
                if (storedNotifsCookiesValues.includes(notifDataAttr) || storedNotifsCookies2Values.includes(notifDataAttr)) {
                    $(notif).find('.notifications-cancel-btn').remove();
                    $(notif).find('.header-info__animal-icon').addClass('adjust');
                    $(notif).removeClass('new-notification');
                }
            });
            calcLengthOfNotifications(); 
        }
    }

    function getCookie(name) {
        let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); 
        return match ? match[1] : null;
    }

    function deleteNotification(e) {
        let cancelBtn = $(e.currentTarget);
        let notificationItem = cancelBtn.parent('.db-notification-item')[0];
        let cookieDataAttr = $(notificationItem).data('notificationid');

        let cookieResult = getCookie('notification');

        if (cookieResult == null) {
            document.cookie = "notification= " + cookieDataAttr;
        } else {
            //add to cookies        
            document.cookie = "notification= " + cookieResult + "," + cookieDataAttr;
        }

        //remove notification from DOM
        cancelBtn.remove();
        $(notificationItem).find('.header-info__animal-icon').addClass('adjust');
        $(notificationItem).removeClass('new-notification');
        calcLengthOfNotifications();
    }

    function clearAll() {
        ui.$NotificationsList.find('.db-notification-item').each((idx,notif) => {
            let notifDataAttr = $(notif).data('notificationid');
            let cookieResult = getCookie('notification');
            
            if (cookieResult == null) {
                document.cookie = "notification= " + notifDataAttr;
            } else {
                //add to cookies       
                document.cookie = "notification= " + cookieResult + "," + notifDataAttr;

                let updatedCookiesResults = getCookie('notification');
                let updatedNotifsCookiesValues = updatedCookiesResults.split(',');

                if (updatedNotifsCookiesValues.includes(notifDataAttr) == false) {
                    notifsSecondArray.push(notifDataAttr);
                }
            }
            $(notif).removeClass('new-notification');
            $(notif).find('.header-info__animal-icon').addClass('adjust');
            $(notif).find('.notifications-cancel-btn').hide();

        });
        addMissedNotifsToCookies();
        calcLengthOfNotifications(); 
    }

    function addMissedNotifsToCookies() {
        $(notifsSecondArray).each((idx,notification) => {
            let notif2CookieResult = getCookie('notification2');
            document.cookie = "notification2= " + notif2CookieResult + "," + notification;
        });
    }

    function calcLengthOfNotifications() {
        numOfNotifications = ui.$NotificationsList.children('li.new-notification').length;

        if (numOfNotifications == 0) {
            ui.$NotificationsCount.hide();
        } else if (numOfNotifications >= 1 && numOfNotifications <= 9) {
            ui.$NotificationsCount.show();
            ui.$NotificationsClearAllBtn.show();
            ui.$NotificationsCount.text(numOfNotifications);
        } else if (numOfNotifications > 9) {
            ui.$NotificationsCount.show();
            ui.$NotificationsClearAllBtn.show();
            ui.$NotificationsCount.text('9+');
        }
    }

    function init() {
        if ($('.dashboard__header').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        checkCookies();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.DashboardHeader.init();
    });
});